
<template>
  <span class="button-root-node">
    <el-tooltip
      effect="dark"
      :content="tip"
      placement="bottom-start"
      trigger="hover"
      :disabled="!(disabled && tip)"
    >
      <button
        class="tm-button"
        :class="[type, { disabled: disabled, ghost: ghost }]"
        @click.stop="handleClick"
      >
        <span class="tm-button__text">
          <slot></slot>
        </span>
      </button>
    </el-tooltip>
  </span>
</template>
<script>
export default {
  name: "TmButton",
  model: {
    event: "click",
  },
  props: {
    // 按钮风格 default primary plain-primary text
    type: {
      type: String,
      default: "",
    },
    // 禁用状态
    disabled: {
      type: Boolean,
      default: false,
    },
    // 禁用提示
    tip: {
      type: String,
    },
    ghost: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    var timer = null,
      clickFlag = false; //防连续点击计时器

    const handleClick = (e) => {
      if (props.disabled == true) {
        return false;
      }

      if (timer) {
        clearTimeout(timer);
      }
      if (!clickFlag) {
        let target = e.target || e.srcElement;
        if (target.nodeName === "SPAN") {
          target.parentNode.blur();
        } else {
          target.blur();
        }
        emit("click");
        clickFlag = true;
      }

      timer = setTimeout(() => {
        clickFlag = false;
      }, 800);
    };
    return {
      handleClick,
    };
  },
};
</script>
<style lang="less" scoped>
.button-root-node {
  display: inline-block;
  vertical-align: middle;
  line-height: 25px;
  height: 30px;
  &[title] {
    :deep(i[class*="tm-icon"]) {
      font-size: 16px;
      vertical-align: baseline;
    }
  }
}
.tm-button {
  position: relative;
  height: 30px;
  padding: 0 10px;
  line-height: 30px;
  border: 1px solid #cbd6ed;
  border-radius: 4px;
  background-color: #fff;
  color: @themeFontColor;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  &:hover {
    background-color: @activeBgColor;
    border-color: #1890fe;
    color: #1890fe;
  }
  &.default {
    color: #353535;
    &:hover {
      opacity: 0.7;
      background: transparent;
    }
  }
  &.primary {
    background-color: #3096fc;
    border-color: #3096fc;
    color: #fff;

    &:hover {
      opacity: 0.8;
    }
  }
  &.text {
    border: none;
    padding: 0 5px;
    width: auto;
    min-width: inherit;

    &:hover {
      background: transparent;
      color: #76b6f1;
    }
  }

  &.disabled {
    background: #fff;
    cursor: not-allowed;
    border-color: #cbcbcb;
    color: #cdcdcd;
  }
  &.ghost {
    background: transparent;
    border-style: dashed;
  }

  :deep(.el-icon--right) {
    vertical-align: middle;
  }
  :deep(i[class*="tm-icon"]) {
    font-size: 12px;
    vertical-align: baseline;
  }
}
</style>
